/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

const openQuickAddToCart = (container) => {
    container?.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
};

const closeQuickAddToCart = (container) => {
    container?.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
};

const selectFirstAvailableVariant = (el) => {
    const variantData = el.querySelector('variant-picker script[type="application/json"]');
    if (!variantData) return;

    const { variants } = JSON.parse(variantData.textContent);
    const firstAvailable = variants.find((v) => v.available);
    if (!firstAvailable) return;

    firstAvailable.options.forEach((optionValue, index) => {
        const optionSelector = el.querySelectorAll('.option-selector')[index];
        if (!optionSelector) return;

        const radio = optionSelector.querySelector(`.opt-btn[value="${CSS.escape(optionValue)}"]`);
        if (radio && !radio.checked) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
};

const hydrateQuickAdd = (el) => {
    if (el.dataset.hydrated) return;
    const tpl = el.querySelector('template');
    if (tpl) {
        el.appendChild(tpl.content.cloneNode(true));
        el.dataset.hydrated = 'true';
    }
};

const addToCartMobile = async (el) => {
    const addBtn = el.querySelector('[data-quick-add-btn]');
    const form = el.querySelector('[data-quick-add-form]');
    if (!form || !addBtn) return;

    const variantId = form.querySelector('input[name="id"]').value;
    if (!variantId) return;

    addBtn.disabled = true;
    addBtn.classList.add('is-loading');

    try {
        const cartDrawerEl = document.querySelector('cart-drawer');
        const pageHeaderEl = document.querySelector('page-header');
        const sectionsToUpdate = [pageHeaderEl, cartDrawerEl].filter(Boolean);
        const sectionIds = sectionsToUpdate.map((sectionEl) => sectionEl.dataset.sectionId);

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sectionIds.join(','));

        const response = await fetch(theme.routes.cartAdd, {
            method: 'POST',
            headers: {
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
        });

        if (!response.ok) throw new Error(`Cart error: ${response.status}`);

        const data = await response.json();

        if (data.sections) {
            sectionsToUpdate.forEach((sectionEl) => {
                const html = data.sections[sectionEl.dataset.sectionId];
                if (html) sectionEl.updateFromCartChange(html);
            });
        }

        const container = el.querySelector('.quick-add-to-cart-container.mobile');
        closeQuickAddToCart(container);
        document.querySelector('.js-cart-drawer')?.open(addBtn);

    } catch (err) {
        console.error('[QuickAdd]', err);
    } finally {
        const addBtn = el.querySelector('[data-quick-add-btn]');
        if (addBtn) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
        }
    }
};

const initQuickAddToCart = () => {
    document.addEventListener('click', (e) => {
        const el = e.target.closest('quick-add-to-cart-mobile');
        if (!el) return;

        if (e.target.closest('.quick-add-to-cart-btn')) {
            hydrateQuickAdd(el);
            const container = el.querySelector('.quick-add-to-cart-container.mobile');
            openQuickAddToCart(container);
            selectFirstAvailableVariant(el);
            return;
        }

        if (e.target.closest('.close-panel')) {
            const container = el.querySelector('.quick-add-to-cart-container.mobile');
            closeQuickAddToCart(container);
            return;
        }

        if (e.target.closest('[data-quick-add-btn]')) {
            addToCartMobile(el);
            return;
        }
    });

    document.addEventListener('on:variant:change', (e) => {
        const el = e.target.closest('quick-add-to-cart-mobile');
        if (!el) return;

        const addBtn = el.querySelector('[data-quick-add-btn]');
        if (!addBtn) return;

        const { variant } = e.detail;
        addBtn.disabled = !variant?.available;
    });
};

if (!window.__quickAddMobileInit) {
    window.__quickAddMobileInit = true;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initQuickAddToCart);
    } else {
        initQuickAddToCart();
    }
}